import { useState } from "react";
import { motion } from "framer-motion";
import { Screen } from "@/components/site/Screen";
import { NavSpots, PageSpots } from "@/components/site/ArtPage";
import { HouseDialog } from "@/components/site/HouseDialog";
import { usePublishedPhotos } from "@/lib/hooks";
import { assetUrl } from "@/lib/api";

// Photo windows inside each drawn Polaroid: [left, top, width, height, rotation]
export const POLAROIDS = [
  [11.4, 29.2, 22, 11.3, -4.5], [41.4, 27.9, 22, 13.1, 2.5], [67.8, 28.3, 23.4, 13.4, -4.5],
  [12.3, 46.1, 22.6, 11.6, 3], [38.9, 45.4, 22.4, 12.4, -4], [64.9, 46.4, 22.8, 12.8, 4],
  [13.9, 63.6, 22.2, 12.2, -5], [39.6, 64, 20.8, 12.2, 2], [65.2, 64.3, 22.2, 12.6, -4],
];

export const GalleryPage = ({ go }) => {
  const photos = usePublishedPhotos();
  const [open, setOpen] = useState(null);
  return (
    <section aria-label="Crown Gallery">
      <Screen page="gallery">
        <NavSpots page="gallery" go={go} />
        <PageSpots page="gallery" go={go} />
        {POLAROIDS.map(([l, t, w, h, r], i) => {
          const src = photos[`gallery-${i + 1}`];
          if (!src) return null;
          return (
            <motion.button
              key={i}
              type="button"
              className="polaroid-photo"
              style={{ left: `${l}%`, top: `${t}%`, width: `${w}%`, height: `${h}%`, rotate: r }}
              initial={{ opacity: 0, scale: 0.94 }}
              animate={{ opacity: 1, scale: 1 }}
              whileHover={{ scale: 1.04 }}
              transition={{ duration: 0.6, delay: 0.08 * i }}
              onClick={() => setOpen(i + 1)}
              aria-label={`View client photo ${i + 1}`}
              data-testid={`gallery-photo-${i + 1}`}
            >
              <img src={assetUrl(src)} alt={`LocdbySmiless client work ${i + 1}`} />
            </motion.button>
          );
        })}
      </Screen>
      <HouseDialog open={!!open} onOpenChange={() => setOpen(null)} title="Crown Work ♡" testId="gallery-lightbox">
        {open ? <img className="lightbox-img" src={assetUrl(photos[`gallery-${open}`])} alt="Client work" /> : null}
      </HouseDialog>
    </section>
  );
};
